package com.essntl.features.area.ui.addeditarea

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditAreaValidation {
    val addEditAreaForm = AddEditAreaForm()
}

class AddEditAreaForm : Form() {
    val name =
        StringField(NonEmptyValidator)

    val countryName =
        StringField(NonEmptyValidator)

    override val fields: List<Field> =
        listOf(name, countryName)
}